import { render, staticRenderFns } from "./ModalVerCostos.vue?vue&type=template&id=be62ef64&"
import script from "./ModalVerCostos.vue?vue&type=script&lang=ts&"
export * from "./ModalVerCostos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('be62ef64', component.options)
    } else {
      api.reload('be62ef64', component.options)
    }
    module.hot.accept("./ModalVerCostos.vue?vue&type=template&id=be62ef64&", function () {
      api.rerender('be62ef64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/OrdenesCompra/ModalVerCostos.vue"
export default component.exports